import { TableHeader } from "@/components/table"
import { ENABLE_ZAPS } from "@/domains/liquidity-page/constants"
import { DisplaySortIcon } from "@/domains/pools/components/display-sort-icon"
import { Sort } from "@/domains/table-processor"

export const ThDisplayName = ({
  setSortBy,
  sortBy,
  name = "Pair",
  colSpan = ENABLE_ZAPS ? 2 : 1,
}: {
  setSortBy: (v: Sort) => void
  sortBy: Sort
  name?: string
  colSpan?: number
}) => {
  return (
    <TableHeader
      className="left-0 pl-4"
      onClick={() => {
        setSortBy({
          key: "displayName",
          direction: sortBy.direction === "asc" ? "desc" : "asc",
          type: "string",
        })
      }}
      colSpan={colSpan}
    >
      {name}
      <DisplaySortIcon sortBy={sortBy} column="displayName" />
    </TableHeader>
  )
}
